import React from 'react'
import "./categories.css"
import Category from '../../components/Category/Category'
import { CategoryType } from '../../layout/Main/Main'

interface CategoriesProps {
  selectedCategory: CategoryType;
  onCategoryChange: (category: CategoryType) => void;
}

const categories = ["overview", "geology", "structure"]

const Categories = ({selectedCategory, onCategoryChange}:CategoriesProps) => {  
  
  return (
    <div id='categories'>
      {categories.map((category, index) => (
        <Category key={index} category={category} index={index} selectedCategory={selectedCategory} onCategoryChange={onCategoryChange}/>
      ))}
    </div>
  )
}

export default Categories
